export function groupByDisabled(options) {
  const grouped = [];
  let currentGroup = null;

  options.forEach(opt => {
    if (opt.disabled) {
      currentGroup = {
        label: opt.label,
        options: [],
      };
      grouped.push(currentGroup);
    } else if (currentGroup) {
      currentGroup.options.push(opt);
    }
  });

  return grouped;
}
